
export const Format = {
    currency: (inputValue: number | null | undefined) => {

        let str = inputValue ? (Math.round(inputValue * 100) / 100).toString() : "";
        str = Number(str).toFixed(2);

        var periodIndex = str.indexOf('.');
        if (periodIndex == -1) periodIndex = str.length;
        var commaIndex = periodIndex - 3;
        if (commaIndex < 0) return str;


        let output = str.substring(0, commaIndex) + ',' + str.substring(commaIndex);


        return output.replace(/^,/, '')

    }
};
